const current = {
    namespaced: true,
    state: {
        search: ''
    },
    mutations: {
        setSearch(state, value) {
            state.search = value;
        }
    }
}

export default current;